"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.claims = void 0;
var utils_1 = require("../../utils");
exports.claims = function (axios) {
    return {
        //클레임 목록 조회
        getClaims: function (request) {
            return axios.get('/claims', request);
        },
        //클레임 목록 조회 V2
        getClaimsV2: function (request) {
            return axios.get('/claims', request);
        },
        // 클레임 엑셀 목록 조회
        getClaimsExcel: function (request) {
            return axios.get('/claims/excel', request);
        },
        getRefundsExcel: function (request) {
            return axios.get('/refunds/excel', request);
        },
        // 클레임 목록에서 사용될 검색조건을 조회
        getClaimsSearchConditions: function (request) {
            return axios.get('/claims/search-conditions', request);
        },
        // 클레임 요약정보 조회
        getClaimsSummary: function (request) {
            return axios.get('/claims/summary', request);
        },
        // 클레임의 세부내역 조회
        /** @deprecated getClaimsNoV2 사용해주세요 */
        getClaimsNo: function (request) {
            var url = utils_1.paramPathchange('/claims/{no}', request);
            return axios.get(url, request);
        },
        // 클레임의 세부내역 조회
        getClaimsNoV2: function (request) {
            var url = utils_1.paramPathchange('/claims/{no}', request);
            return axios.get(url, request);
        },
        // 클레임 철회시 유효성 검증 타입 조회
        getClaimsNoCheckWithdraw: function (request) {
            var url = utils_1.paramPathchange('/claims/{no}/check-withdraw', request);
            return axios.get(url, request);
        },
        // 클레임 지연 요약정보 조회
        getClaimsSummaryDelay: function (request) {
            return axios.get('/claims/summary/delay', request);
        },
        /** @deprecated  getClaimsOrderOptionsOrderOptionNoApplyV2 사용해주세요 */
        getClaimsOrderOptionsOrderOptionNoApply: function (request) {
            var url = utils_1.paramPathchange('/claims/order-options/{orderOptionNo}/apply', request);
            return axios.get(url, request);
        },
        // 클레임 신청을 위한 정보 조회
        getClaimsOrderOptionsOrderOptionNoApplyV2: function (request) {
            var url = utils_1.paramPathchange('/claims/order-options/{orderOptionNo}/apply', request);
            return axios.get(url, request);
        },
        // 주문상세 - 추가결제내역 조회
        getClaimsOrdersOrderNoAdditionalPays: function (request) {
            var url = utils_1.paramPathchange('/claims/orders/{orderNo}/additional-pays', request);
            return axios.get(url, request);
        },
        // 주문상세 - 환불내역 조회
        getClaimsOrdersOrderNoRefunds: function (request) {
            var url = utils_1.paramPathchange('/claims/orders/{orderNo}/refunds', request);
            return axios.get(url, request);
        },
        // 클레임 설정
        getClaimsConfigs: function (request) {
            return axios.get('/claims/configs', request);
        },
        postClaimsConfigs: function (request) {
            return axios.post('/claims/configs', request.data);
        },
        putClaimsConfigs: function (request) {
            return axios.put('/claims/configs', request.data);
        },
        // "클레임"상태 변경별 유효성 검사
        postClaimsValidateOrderStatus: function (request) {
            return axios.post('/claims/validate-claim-status', request.data);
        },
        // "주문"상태 변경별 유효성 검사
        postClaimsValidateOrderStatusOrder: function (request) {
            return axios.post('/claims/validate-order-status', request.data);
        }
    };
};
